// extracted by mini-css-extract-plugin
module.exports = {"container":"AskAQuestion_container__2EtAp","button":"AskAQuestion_button__2Gvab"};